<div mat-dialog-title
    class="title">
    <div class="subtitle">{{ formTitle | translate }}</div>
    <div class="ath-name">{{ athlete.user.firstName + ' ' + athlete.user.lastName }}</div>
</div>

<div class="line line-margin">
    <mat-icon>phone</mat-icon>
    {{ athlete.user.phoneNumber | default:'-' }}
</div>

<div class="line line-margin">
    <mat-icon>email</mat-icon>
    <a href="mailto:{{ athlete.user.email }}">{{ athlete.user.email | default:'-' }}</a>
</div>

<div class="line line-margin">
    <mat-icon>room</mat-icon>
    <div *ngIf="athlete.addresses.length > 0; else boxContent">
        {{ athlete.addresses[0].streetName | default:'-' }} {{ athlete.addresses[0].buildingNumber | default: '' }}<br />
        <span *ngIf="athlete.addresses[0].addressAddition">{{ athlete.addresses[0].addressAddition }}<br /></span>
        {{ athlete.addresses[0].postcode | default: '' }} {{ athlete.addresses[0].city | default: '' }}<br />
        <span *ngIf="athlete.addresses[0].country">{{ athlete.addresses[0].country }}</span>
    </div>

    <ng-template #boxContent>
        -
    </ng-template>
</div>

<div>
    <button mat-raised-button
            mat-dialog-close
            color="accent">
        {{ 'Close' | translate}}
    </button>
</div>
